import { SET_LANE_MANAGEMENT_KPI_REQUEST,
        SET_LANE_MANAGEMENT_KPI_SUCCESS,
        SET_LANE_MANAGEMENT_KPI_ERROR,
        SET_LANE_MANAGEMENT_KPI_RESET,

        SET_LONGITUDINAL_MOTION_KPI_REQUEST,
        SET_LONGITUDINAL_MOTION_KPI_SUCCESS,
        SET_LONGITUDINAL_MOTION_KPI_ERROR,
        SET_LONGITUDINAL_MOTION_KPI_RESET,

        SET_SAFE_DRIVING_KPI_REQUEST,
        SET_SAFE_DRIVING_KPI_SUCCESS,
        SET_SAFE_DRIVING_KPI_ERROR,
        SET_SAFE_DRIVING_KPI_RESET,

        SET_EGO_VELOCITY_KPI_REQUEST,
        SET_EGO_VELOCITY_KPI_SUCCESS,
        SET_EGO_VELOCITY_KPI_ERROR,
        SET_EGO_VELOCITY_KPI_RESET,

        SET_L1_LATERAL_ACCELERATION_KPI_REQUEST,
        SET_L1_LATERAL_ACCELERATION_KPI_SUCCESS,
        SET_L1_LATERAL_ACCELERATION_KPI_ERROR,
        SET_L1_LATERAL_ACCELERATION_KPI_RESET,

        SET_L1_LATERAL_JERK_KPI_REQUEST,
        SET_L1_LATERAL_JERK_KPI_SUCCESS,
        SET_L1_LATERAL_JERK_KPI_ERROR,
        SET_L1_LATERAL_JERK_KPI_RESET,

        SET_L1_LONGITUDINAL_DECELERATION_KPI_REQUEST,
        SET_L1_LONGITUDINAL_DECELERATION_KPI_SUCCESS,
        SET_L1_LONGITUDINAL_DECELERATION_KPI_ERROR,
        SET_L1_LONGITUDINAL_DECELERATION_KPI_RESET,

        SET_L1_LONGITUDINAL_ACCELERATION_KPI_REQUEST,
        SET_L1_LONGITUDINAL_ACCELERATION_KPI_SUCCESS,
        SET_L1_LONGITUDINAL_ACCELERATION_KPI_ERROR,
        SET_L1_LONGITUDINAL_ACCELERATION_KPI_RESET,

        SET_L1_LONGITUDINAL_JERK_KPI_REQUEST,
        SET_L1_LONGITUDINAL_JERK_KPI_SUCCESS,
        SET_L1_LONGITUDINAL_JERK_KPI_ERROR,
        SET_L1_LONGITUDINAL_JERK_KPI_RESET,

        SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_REQUEST,
        SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_SUCCESS,
        SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_ERROR,
        SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_RESET,

        SET_L0_COLLISION_CHECK_KPI_REQUEST,
        SET_L0_COLLISION_CHECK_KPI_SUCCESS,
        SET_L0_COLLISION_CHECK_KPI_ERROR,
        SET_L0_COLLISION_CHECK_KPI_RESET,

        SET_L0_LATERAL_SAFE_DISTANCE_KPI_REQUEST,
        SET_L0_LATERAL_SAFE_DISTANCE_KPI_SUCCESS,
        SET_L0_LATERAL_SAFE_DISTANCE_KPI_ERROR,
        SET_L0_LATERAL_SAFE_DISTANCE_KPI_RESET,

        SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_REQUEST,
        SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_SUCCESS,
        SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_ERROR,
        SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_RESET,

        SET_L0_OFF_ROAD_CHECK_KPI_REQUEST,
        SET_L0_OFF_ROAD_CHECK_KPI_SUCCESS,
        SET_L0_OFF_ROAD_CHECK_KPI_ERROR,
        SET_L0_OFF_ROAD_CHECK_KPI_RESET,

        SET_L0_LANE_MARKING_CHECK_KPI_REQUEST,
        SET_L0_LANE_MARKING_CHECK_KPI_SUCCESS,
        SET_L0_LANE_MARKING_CHECK_KPI_ERROR,
        SET_L0_LANE_MARKING_CHECK_KPI_RESET,

        SET_L0_INDICATOR_CHECKING_KPI_SUCCESS,
        SET_L0_INDICATOR_CHECKING_KPI_ERROR,
        SET_L0_INDICATOR_CHECKING_KPI_REQUEST,
        SET_L0_INDICATOR_CHECKING_KPI_RESET,

        SET_L0_SPEED_LIMIT_CHECK_KPI_REQUEST,
        SET_L0_SPEED_LIMIT_CHECK_KPI_SUCCESS,
        SET_L0_SPEED_LIMIT_CHECK_KPI_ERROR,
        SET_L0_SPEED_LIMIT_CHECK_KPI_RESET,

        SET_L0_FALSE_INDICATOR_CHECK_KPI_REQUEST,
        SET_L0_FALSE_INDICATOR_CHECK_KPI_SUCCESS,
        SET_L0_FALSE_INDICATOR_CHECK_KPI_ERROR,
        SET_L0_FALSE_INDICATOR_CHECK_KPI_RESET,

        SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_REQUEST,
        SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_SUCCESS,
        SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_ERROR,
        SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_RESET,

        SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_REQUEST,
        SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_SUCCESS,
        SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_ERROR,
        SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_RESET,

        SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_REQUEST,
        SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_SUCCESS,
        SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_ERROR,
        SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_RESET, } from './../../../../constants/closeLoop/kpiDashboard/dashboardGraphs/dashboardGraphConstants';

const INITIAL_STATE = {
    laneManagementKPI: {
        loading: false,
        error: '',
        laneAvailability: {
            availability: 0,
            nonAvailability: 0
        },
        laneOffset: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const dashboardGraphReducer = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_LANE_MANAGEMENT_KPI_REQUEST:
            return {
                ...state,
                laneManagementKPI: {
                    ...state.laneManagementKPI,
                    loading: true
                }
            }

        case SET_LANE_MANAGEMENT_KPI_SUCCESS:
            return {
                ...state,
                laneManagementKPI: {
                    ...state.laneManagementKPI,
                    loading: false,
                    error: '',
                    laneAvailability: {
                        availability: action.payload['lane_availability']['availability'],
                        nonAvailability: action.payload['lane_availability']['non-availability']
                    },
                    laneOffset: {
                        xAxis: action.payload['lane_offset']['x-axis'],
                        yAxis: action.payload['lane_offset']['y-axis']
                    }
                }
            }

        case SET_LANE_MANAGEMENT_KPI_ERROR:
            return {
                ...state,
                laneManagementKPI: {
                    ...state.laneManagementKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_LANE_MANAGEMENT_KPI_RESET:
            return INITIAL_STATE;

        default:
            return state;
    }
}


const LONGITUDINAL_MOTION_INITIAL_STATE = {
    longitudinalMotionKPI: {
        loading: false,
        error: '',
        jerks: {
            xAxis: [],
            yAxis: []
        },
        acceleration: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const longitudinalMotionKPIReducer = (state=LONGITUDINAL_MOTION_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_LONGITUDINAL_MOTION_KPI_REQUEST:
            return {
                ...state,
                longitudinalMotionKPI: {
                    ...state.longitudinalMotionKPI,
                    loading: true
                }
            }

        case SET_LONGITUDINAL_MOTION_KPI_SUCCESS:
            return {
                ...state,
                longitudinalMotionKPI: {
                    ...state.longitudinalMotionKPI,
                    loading: false,
                    error: '',
                    jerks: {
                        xAxis: action.payload['jerks']['x-axis'],
                        yAxis: action.payload['jerks']['y-axis']
                    },
                    acceleration: {
                        xAxis: action.payload['acceleration']['x-axis'],
                        yAxis: action.payload['acceleration']['y-axis']
                    }
                }
            }

        case SET_LONGITUDINAL_MOTION_KPI_ERROR:
            return {
                ...state,
                longitudinalMotionKPI: {
                    ...state.longitudinalMotionKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_LONGITUDINAL_MOTION_KPI_RESET:
            return LONGITUDINAL_MOTION_INITIAL_STATE;

        default:
            return state;
    }
}


const SAFE_DRIVING_INITIAL_STATE = {
    safeDrivingKPI: {
        loading: false,
        error: '',
        timeToCollision: {
            xAxis: [],
            yAxis: []
        },
        relativeDistance: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const safeDrivingKPIReducer = (state=SAFE_DRIVING_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_SAFE_DRIVING_KPI_REQUEST:
            return {
                ...state,
                safeDrivingKPI: {
                    ...state.safeDrivingKPI,
                    loading: true
                }
            }

        case SET_SAFE_DRIVING_KPI_SUCCESS:
            return {
                ...state,
                safeDrivingKPI: {
                    ...state.safeDrivingKPI,
                    loading: false,
                    error: '',
                    timeToCollision: {
                        xAxis: action.payload['time_to_collision']['x-axis'],
                        yAxis: action.payload['time_to_collision']['y-axis']
                    },
                    relativeDistance: {
                        xAxis: action.payload['relative_distance']['x-axis'],
                        yAxis: action.payload['relative_distance']['y-axis']
                    }
                }
            }

        case SET_SAFE_DRIVING_KPI_ERROR:
            return {
                ...state,
                safeDrivingKPI: {
                    ...state.safeDrivingKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_SAFE_DRIVING_KPI_RESET:
            return SAFE_DRIVING_INITIAL_STATE;

        default:
            return state;
    }
}

const EGO_VELOCITY_INITIAL_STATE = {
    egoVelocityKPI: {
        loading: false,
        error: '',
        egoVelocity: {
            xAxis: [],
            yAxis: []
        },
        targetVelocity: {
            xAxis: [],
            yAxis: []
        }
    }
};


export const egoVelocityKPIReducer = (state=EGO_VELOCITY_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_EGO_VELOCITY_KPI_REQUEST:
            return {
                ...state,
                egoVelocityKPI: {
                    ...state.egoVelocityKPI,
                    loading: true
                }
            }

        case SET_EGO_VELOCITY_KPI_SUCCESS:
            return {
                ...state,
                egoVelocityKPI: {
                    ...state.egoVelocityKPI,
                    loading: false,
                    error: '',
                    egoVelocity: {
                        xAxis: action.payload['ego_velocity']['x-axis'],
                        yAxis: action.payload['ego_velocity']['y-axis']
                    },
                    targetVelocity: {
                        xAxis: action.payload['target_velocity']['x-axis'],
                        yAxis: action.payload['target_velocity']['y-axis']
                    }
                }
            }

        case SET_EGO_VELOCITY_KPI_ERROR:
            return {
                ...state,
                egoVelocityKPI: {
                    ...state.egoVelocityKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_EGO_VELOCITY_KPI_RESET:
            return EGO_VELOCITY_INITIAL_STATE;

        default:
            return state;
    }
}

const L1_LATERAL_ACCELERATION_KPI_INITIAL_STATE = {
    l1LateralAccelerationKPI: {
        loading: false,
        error: '',
        egoAcceleration: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}

export const l1LateralAccelerationKPIReducer = (state=L1_LATERAL_ACCELERATION_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L1_LATERAL_ACCELERATION_KPI_REQUEST:
            return {
                ...state,
                l1LateralAccelerationKPI: {
                    ...state.l1LateralAccelerationKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L1_LATERAL_ACCELERATION_KPI_SUCCESS:
            return {
                ...state,
                l1LateralAccelerationKPI: {
                    ...state.l1LateralAccelerationKPI,
                    loading: false,
                    error: '',
                    egoAcceleration: {
                        xAxis: action.payload['ego_acceleration']['x-axis'],
                        yAxis: action.payload['ego_acceleration']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L1_LATERAL_ACCELERATION_KPI_ERROR:
            return {
                ...state,
                l1LateralAccelerationKPI: {
                    ...state.l1LateralAccelerationKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L1_LATERAL_ACCELERATION_KPI_RESET:
            return L1_LATERAL_ACCELERATION_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const L1_LATERAL_JERK_KPI_INITIAL_STATE = {
    l1LateralJerkKPI: {
        loading: false,
        error: '',
        lateralJerk: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l1LateralJerkKPIReducer = (state=L1_LATERAL_JERK_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L1_LATERAL_JERK_KPI_REQUEST:
            return {
                ...state,
                l1LateralJerkKPI: {
                    ...state.l1LateralJerkKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L1_LATERAL_JERK_KPI_SUCCESS:
            return {
                ...state,
                l1LateralJerkKPI: {
                    ...state.l1LateralJerkKPI,
                    loading: false,
                    error: '',
                    lateralJerk: {
                        xAxis: action.payload['lateral_jerk']['x-axis'],
                        yAxis: action.payload['lateral_jerk']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L1_LATERAL_JERK_KPI_ERROR:
            return {
                ...state,
                l1LateralJerkKPI: {
                    ...state.l1LateralJerkKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L1_LATERAL_JERK_KPI_RESET:
            return L1_LATERAL_JERK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}


const L1_LONGITUDINAL_DECELERATION_KPI_INITIAL_STATE = {
    l1LongitudinalDecelerationKPI: {
        loading: false,
        error: '',
        egoAccelerationX: {
            xAxis: [],
            yAxis: []
        },
        egoVelocityX: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l1LongitudinalDecelerationKPIReducer = (state=L1_LONGITUDINAL_DECELERATION_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L1_LONGITUDINAL_DECELERATION_KPI_REQUEST:
            return {
                ...state,
                l1LongitudinalDecelerationKPI: {
                    ...state.l1LongitudinalDecelerationKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L1_LONGITUDINAL_DECELERATION_KPI_SUCCESS:
            return {
                ...state,
                l1LongitudinalDecelerationKPI: {
                    ...state.l1LongitudinalDecelerationKPI,
                    loading: false,
                    error: '',
                    egoAccelerationX: {
                        xAxis: action.payload['ego_acceleration_x']['x-axis'],
                        yAxis: action.payload['ego_acceleration_x']['y-axis']
                    },
                    egoVelocityX: {
                        xAxis: action.payload['ego_velocity_x']['x-axis'],
                        yAxis: action.payload['ego_velocity_x']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L1_LONGITUDINAL_DECELERATION_KPI_ERROR:
            return {
                ...state,
                l1LongitudinalDecelerationKPI: {
                    ...state.l1LongitudinalDecelerationKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L1_LONGITUDINAL_DECELERATION_KPI_RESET:
            return L1_LONGITUDINAL_DECELERATION_KPI_INITIAL_STATE;

        default:
            return state;
    }
}


const L1_LONGITUDINAL_ACCELERATION_KPI_INITIAL_STATE = {
    l1LongitudinalAccelerationKPI: {
        loading: false,
        error: '',
        egoAccelerationX: {
            xAxis: [],
            yAxis: []
        },
        egoVelocityX: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l1LongitudinalAccelerationKPIReducer = (state=L1_LONGITUDINAL_ACCELERATION_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L1_LONGITUDINAL_ACCELERATION_KPI_REQUEST:
            return {
                ...state,
                l1LongitudinalAccelerationKPI: {
                    ...state.l1LongitudinalAccelerationKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L1_LONGITUDINAL_ACCELERATION_KPI_SUCCESS:
            return {
                ...state,
                l1LongitudinalAccelerationKPI: {
                    ...state.l1LongitudinalAccelerationKPI,
                    loading: false,
                    error: '',
                    egoAccelerationX: {
                        xAxis: action.payload['ego_acceleration_x']['x-axis'],
                        yAxis: action.payload['ego_acceleration_x']['y-axis']
                    },
                    egoVelocityX: {
                        xAxis: action.payload['ego_velocity_x']['x-axis'],
                        yAxis: action.payload['ego_velocity_x']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L1_LONGITUDINAL_ACCELERATION_KPI_ERROR:
            return {
                ...state,
                l1LongitudinalAccelerationKPI: {
                    ...state.l1LongitudinalAccelerationKPI,
                    loading: false,
                    error: action.payload,
                }
            }

        case SET_L1_LONGITUDINAL_ACCELERATION_KPI_RESET:
            return L1_LONGITUDINAL_ACCELERATION_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const L1_LONGITUDINAL_JERK_KPI_INITIAL_STATE = {
    l1LongitudinalJerkKPI: {
        loading: false,
        error: '',
        longitudinalJerk: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l1LongitudinalJerkKPIReducer = (state=L1_LONGITUDINAL_JERK_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L1_LONGITUDINAL_JERK_KPI_REQUEST:
            return {
                ...state,
                l1LongitudinalJerkKPI: {
                    ...state.l1LongitudinalJerkKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L1_LONGITUDINAL_JERK_KPI_SUCCESS:
            return {
                ...state,
                l1LongitudinalJerkKPI: {
                    ...state.l1LongitudinalJerkKPI,
                    loading: false,
                    error: '',
                    longitudinalJerk: {
                        xAxis: action.payload['longitudinal_jerk']['x-axis'],
                        yAxis: action.payload['longitudinal_jerk']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L1_LONGITUDINAL_JERK_KPI_ERROR:
            return {
                ...state,
                l1LongitudinalJerkKPI: {
                    ...state.l1LongitudinalJerkKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L1_LONGITUDINAL_JERK_KPI_RESET:
            return L1_LONGITUDINAL_JERK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const L1_LONGITUDINAL_VELOCITY_DROP_KPI_INITIAL_STATE = {
    l1LongitudinalVelocityDropKPI: {
        loading: false,
        error: '',
        egoVelocityXDrop: {
            xAxis: [],
            yAxis: []
        },
        egoAccelerationX: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l1LongitudinalVelocityDropKPIReducer = (state=L1_LONGITUDINAL_VELOCITY_DROP_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_REQUEST:
            return {
                ...state,
                l1LongitudinalVelocityDropKPI: {
                    ...state.l1LongitudinalVelocityDropKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_SUCCESS:
            return {
                ...state,
                l1LongitudinalVelocityDropKPI: {
                    ...state.l1LongitudinalVelocityDropKPI,
                    loading: false,
                    error: '',
                    egoVelocityXDrop: {
                        xAxis: action.payload['ego_velocity_x_drop']['x-axis'],
                        yAxis: action.payload['ego_velocity_x_drop']['y-axis']
                    },
                    egoAccelerationX: {
                        xAxis: action.payload['ego_acceleration_x']['x-axis'],
                        yAxis: action.payload['ego_acceleration_x']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_ERROR:
            return {
                ...state,
                l1LongitudinalVelocityDropKPI: {
                    ...state.l1LongitudinalVelocityDropKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_RESET:
            return L1_LONGITUDINAL_VELOCITY_DROP_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const L0_COLLISION_CHECK_KPI_INITIAL_STATE = {
    l0CollisionCheckKPI: {
        loading: false,
        error: '',
        longitudinalGapWithTV: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}

export const l0CollisionCheckKPIReducer = (state=L0_COLLISION_CHECK_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L0_COLLISION_CHECK_KPI_REQUEST:
            return {
                ...state,
                l0CollisionCheckKPI: {
                    ...state.l0CollisionCheckKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L0_COLLISION_CHECK_KPI_SUCCESS:
            return {
                ...state,
                l0CollisionCheckKPI: {
                    ...state.l0CollisionCheckKPI,
                    loading: false,
                    error: '',
                    longitudinalGapWithTV: {
                        xAxis: action.payload['longitudinal_gap_with_tv']['x-axis'],
                        yAxis: action.payload['longitudinal_gap_with_tv']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L0_COLLISION_CHECK_KPI_ERROR:
            return {
                ...state,
                l0CollisionCheckKPI: {
                    ...state.l0CollisionCheckKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L0_COLLISION_CHECK_KPI_RESET:
            return L0_COLLISION_CHECK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}


const L0_LATERAL_SAFE_DISTANCE_KPI_INITIAL_STATE = {
    l0lateralSafeDistanceKPI: {
        loading: false,
        error: '',
        lateralGapWithTV: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l0lateralSafeDistanceKPIReducer = (state=L0_LATERAL_SAFE_DISTANCE_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L0_LATERAL_SAFE_DISTANCE_KPI_REQUEST:
            return {
                ...state,
                l0lateralSafeDistanceKPI: {
                    ...state.l0lateralSafeDistanceKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L0_LATERAL_SAFE_DISTANCE_KPI_SUCCESS:
            return {
                ...state,
                l0lateralSafeDistanceKPI: {
                    ...state.l0lateralSafeDistanceKPI,
                    loading: false,
                    error: '',
                    lateralGapWithTV: {
                        xAxis: action.payload['lateral_gap_with_tv']['x-axis'],
                        yAxis: action.payload['lateral_gap_with_tv']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L0_LATERAL_SAFE_DISTANCE_KPI_ERROR:
            return {
                ...state,
                l0lateralSafeDistanceKPI: {
                    ...state.l0lateralSafeDistanceKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L0_LATERAL_SAFE_DISTANCE_KPI_RESET:
            return L0_LATERAL_SAFE_DISTANCE_KPI_INITIAL_STATE;

        default:
            return state;
    }
}


const L0_LONGITUDINAL_SAFE_DISTANCE_KPI_INITIAL_STATE = {
    l0LongitudinalSafeDistanceKPI: {
        loading: false,
        error: '',
        longitudinalSafeDistance: {
            xAxis: [],
            yAxis: []
        },
        longitudinalGapWithTV: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l0LongitudinalSafeDistanceKPIReducer = (state=L0_LONGITUDINAL_SAFE_DISTANCE_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_REQUEST:
            return {
                ...state,
                l0LongitudinalSafeDistanceKPI: {
                    ...state.l0LongitudinalSafeDistanceKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_SUCCESS:
            return {
                ...state,
                l0LongitudinalSafeDistanceKPI: {
                    ...state.l0LongitudinalSafeDistanceKPI,
                    loading: false,
                    error: '',
                    longitudinalSafeDistance: {
                        xAxis: action.payload['longitudinal_safe_distance']['x-axis'],
                        yAxis: action.payload['longitudinal_safe_distance']['y-axis']
                    },
                    longitudinalGapWithTV: {
                        xAxis: action.payload['longitudinal_gap_with_tv']['x-axis'],
                        yAxis: action.payload['longitudinal_gap_with_tv']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_ERROR:
            return {
                ...state,
                l0LongitudinalSafeDistanceKPI: {
                    ...state.l0LongitudinalSafeDistanceKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_RESET:
            return L0_LONGITUDINAL_SAFE_DISTANCE_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const L0_OFF_ROAD_CHECK_KPI_INITIAL_STATE = {
    l0OffRoadCheckKPI: {
        loading: false,
        error: '',
        laneOffset: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}

export const l0OffRoadCheckKPIReducer = (state=L0_OFF_ROAD_CHECK_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L0_OFF_ROAD_CHECK_KPI_REQUEST:
            return {
                ...state,
                l0OffRoadCheckKPI: {
                    ...state.l0OffRoadCheckKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L0_OFF_ROAD_CHECK_KPI_SUCCESS:
            return {
                ...state,
                l0OffRoadCheckKPI: {
                    ...state.l0OffRoadCheckKPI,
                    loading: false,
                    error: '',
                    laneOffset: {
                        xAxis: action.payload['lane_offset']['x-axis'],
                        yAxis: action.payload['lane_offset']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L0_OFF_ROAD_CHECK_KPI_ERROR:
            return {
                ...state,
                l0OffRoadCheckKPI: {
                    ...state.l0OffRoadCheckKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L0_OFF_ROAD_CHECK_KPI_RESET:
            return L0_OFF_ROAD_CHECK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const L0_LANE_MARKING_CHECK_KPI_INITIAL_STATE = {
    l0LaneMarkingCheckKPI: {
        loading: false,
        error: '',
        laneOffset: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}

export const l0LaneMarkingCheckKPIReducer = (state=L0_LANE_MARKING_CHECK_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_L0_LANE_MARKING_CHECK_KPI_REQUEST:
            return {
                ...state,
                l0LaneMarkingCheckKPI: {
                    ...state.l0LaneMarkingCheckKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L0_LANE_MARKING_CHECK_KPI_SUCCESS:
            return {
                ...state,
                l0LaneMarkingCheckKPI: {
                    ...state.l0LaneMarkingCheckKPI,
                    loading: false,
                    error: '',
                    laneOffset: {
                        xAxis: action.payload['lane_offset']['x-axis'],
                        yAxis: action.payload['lane_offset']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L0_LANE_MARKING_CHECK_KPI_ERROR:
            return {
                ...state,
                l0LaneMarkingCheckKPI: {
                    ...state.l0LaneMarkingCheckKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L0_LANE_MARKING_CHECK_KPI_RESET:
            return L0_LANE_MARKING_CHECK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}


const L0_INDICATOR_CHECKING_KPI_INITIAL_STATE = {
    l0IndicatorCheckingKPI: {
        loading: false,
        error: '',
        laneOffset: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l0IndicatorCheckingKPIReducer = (state=L0_INDICATOR_CHECKING_KPI_INITIAL_STATE, action) => {
    switch(action.type){
        case SET_L0_INDICATOR_CHECKING_KPI_REQUEST:
            return {
                ...state,
                l0IndicatorCheckingKPI: {
                    ...state.l0IndicatorCheckingKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L0_INDICATOR_CHECKING_KPI_SUCCESS:
            return {
                ...state,
                l0IndicatorCheckingKPI: {
                    ...state.l0IndicatorCheckingKPI,
                    loading: false,
                    error: '',
                    laneOffset: {
                        xAxis: action.payload['lane_offset']['x-axis'],
                        yAxis: action.payload['lane_offset']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L0_INDICATOR_CHECKING_KPI_ERROR:
            return {
                ...state,
                l0IndicatorCheckingKPI: {
                    ...state.l0IndicatorCheckingKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L0_INDICATOR_CHECKING_KPI_RESET:
            return L0_INDICATOR_CHECKING_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const L0_SPEED_LIMIT_CHECK_KPI_INITIAL_STATE = {
    l0SpeedLimitCheckKPI: {
        loading: false,
        error: '',
        speedLimit: {
            xAxis: [],
            yAxis: []
        },
        egoVelocityY: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l0SpeedLimitCheckKPIReducer = (state=L0_SPEED_LIMIT_CHECK_KPI_INITIAL_STATE, action) => {
    switch(action.type){
        case SET_L0_SPEED_LIMIT_CHECK_KPI_REQUEST:
            return {
                ...state,
                l0SpeedLimitCheckKPI: {
                    ...state.l0SpeedLimitCheckKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L0_SPEED_LIMIT_CHECK_KPI_SUCCESS:
            return {
                ...state,
                l0SpeedLimitCheckKPI: {
                    ...state.l0SpeedLimitCheckKPI,
                    loading: false,
                    error: '',
                    speedLimit: {
                        xAxis: action.payload['speed_limit']['x-axis'],
                        yAxis: action.payload['speed_limit']['y-axis']
                    },
                    egoVelocityY: {
                        xAxis: action.payload['ego_velocity_y']['x-axis'],
                        yAxis: action.payload['ego_velocity_y']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L0_SPEED_LIMIT_CHECK_KPI_ERROR:
            return {
                ...state,
                l0SpeedLimitCheckKPI: {
                    ...state.l0SpeedLimitCheckKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L0_SPEED_LIMIT_CHECK_KPI_RESET:
            return L0_SPEED_LIMIT_CHECK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const L0_FALSE_INDICATOR_CHECK_KPI_INITIAL_STATE = {
    l0FalseIndicatorCheckKPI: {
        loading: false,
        error: '',
        laneOffset: {
            xAxis: [],
            yAxis: []
        },
        kpiPass: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const l0FalseIndicatorCheckKPIReducer = (state=L0_FALSE_INDICATOR_CHECK_KPI_INITIAL_STATE, action) => {
    switch(action.type){
        case SET_L0_FALSE_INDICATOR_CHECK_KPI_REQUEST:
            return {
                ...state,
                l0FalseIndicatorCheckKPI: {
                    ...state.l0FalseIndicatorCheckKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_L0_FALSE_INDICATOR_CHECK_KPI_SUCCESS:
            return {
                ...state,
                l0FalseIndicatorCheckKPI: {
                    ...state.l0FalseIndicatorCheckKPI,
                    loading: false,
                    error: '',
                    laneOffset: {
                        xAxis: action.payload['lane_offset']['x-axis'],
                        yAxis: action.payload['lane_offset']['y-axis']
                    },
                    kpiPass: {
                        xAxis: action.payload['kpi_pass']['x-axis'],
                        yAxis: action.payload['kpi_pass']['y-axis']
                    }
                }
            }

        case SET_L0_FALSE_INDICATOR_CHECK_KPI_ERROR:
            return {
                ...state,
                l0FalseIndicatorCheckKPI: {
                    ...state.l0FalseIndicatorCheckKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_L0_FALSE_INDICATOR_CHECK_KPI_RESET:
            return L0_FALSE_INDICATOR_CHECK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}

const RSS_LONGITUDINAL_SAFE_CHECK_KPI_INITIAL_STATE = {
    rssLongitudinalSafeCheckKPI: {
        loading: false,
        error: '',
        rssLongitudinalCurrent: {
            xAxis: [],
            yAxis: []
        },
        rssLongitudinalSafe: {
            xAxis: [],
            yAxis: []
        },
        rssLongitudinalFlag: {
            xAxis: [],
            yAxis: []
        },
        overallRSSFlag: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const rssLongitudinalSafeCheckKPIReducer = (state=RSS_LONGITUDINAL_SAFE_CHECK_KPI_INITIAL_STATE, action) => {
    switch(action.type){
        case SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_REQUEST:
            return {
                ...state,
                rssLongitudinalSafeCheckKPI: {
                    ...state.rssLongitudinalSafeCheckKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_SUCCESS:
            return {
                ...state,
                rssLongitudinalSafeCheckKPI: {
                    loading: false,
                    error: '',
                    rssLongitudinalCurrent: {
                        xAxis: action.payload['rss_longitudinal_current']['x-axis'],
                        yAxis: action.payload['rss_longitudinal_current']['y-axis']
                    },
                    rssLongitudinalSafe: {
                        xAxis: action.payload['rss_longitudinal_safe']['x-axis'],
                        yAxis: action.payload['rss_longitudinal_safe']['y-axis']
                    },
                    rssLongitudinalFlag: {
                        xAxis: action.payload['rss_longitudinal_flag']['x-axis'],
                        yAxis: action.payload['rss_longitudinal_flag']['y-axis']
                    },
                    overallRSSFlag: {
                        xAxis: action.payload['overall_rss_flag']['x-axis'],
                        yAxis: action.payload['overall_rss_flag']['y-axis']
                    }
                }
            }

        case SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_ERROR:
            return {
                ...state,
                rssLongitudinalSafeCheckKPI: {
                    ...state.rssLongitudinalSafeCheckKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_RESET:
            return RSS_LONGITUDINAL_SAFE_CHECK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}


const RSS_LATERAL_LEFT_SAFE_CHECK_KPI_INITIAL_STATE = {
    rssLateralLeftSafeCheckKPI: {
        loading: false,
        error: '',
        rssLateralLeftCurrent: {
            xAxis: [],
            yAxis: []
        },
        rssLateralLeftSafe: {
            xAxis: [],
            yAxis: []
        },
        rssLateralLeftFlag: {
            xAxis: [],
            yAxis: []
        },
        overallRSSFlag: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const rssLateralLeftSafeCheckKPIReducer = (state=RSS_LATERAL_LEFT_SAFE_CHECK_KPI_INITIAL_STATE, action) => {
    switch(action.type){
        case SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_REQUEST:
            return {
                ...state,
                rssLateralLeftSafeCheckKPI: {
                    ...state.rssLateralLeftSafeCheckKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_SUCCESS:
            return {
                ...state,
                rssLateralLeftSafeCheckKPI: {
                    ...state.rssLateralLeftSafeCheckKPI,
                    loading: false,
                    error: '',
                    rssLateralLeftCurrent: {
                        xAxis: action.payload['rss_lateral_left_current']['x-axis'],
                        yAxis: action.payload['rss_lateral_left_current']['y-axis']
                    },
                    rssLateralLeftSafe: {
                        xAxis: action.payload['rss_lateral_left_safe']['x-axis'],
                        yAxis: action.payload['rss_lateral_left_safe']['y-axis']
                    },
                    rssLateralLeftFlag: {
                        xAxis: action.payload['rss_lateral_left_flag']['x-axis'],
                        yAxis: action.payload['rss_lateral_left_flag']['y-axis']
                    },
                    overallRSSFlag: {
                        xAxis: action.payload['overall_rss_flag']['x-axis'],
                        yAxis: action.payload['overall_rss_flag']['y-axis']
                    }
                }
            }

        case SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_ERROR:
            return {
                ...state,
                rssLateralLeftSafeCheckKPI: {
                    ...state.rssLateralLeftSafeCheckKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_RESET:
            return RSS_LATERAL_LEFT_SAFE_CHECK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}


const RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_INITIAL_STATE = {
    rssLateralRightSafeCheckKPI: {
        loading: false,
        error: '',
        rssLateralRightCurrent: {
            xAxis: [],
            yAxis: []
        },
        rssLateralRightSafe: {
            xAxis: [],
            yAxis: []
        },
        rssLateralRightFlag: {
            xAxis: [],
            yAxis: []
        },
        overallRSSFlag: {
            xAxis: [],
            yAxis: []
        }
    }
}


export const rssLateralRightSafeCheckKPIReducer = (state=RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_REQUEST:
            return {
                ...state,
                rssLateralRightSafeCheckKPI: {
                    ...state.rssLateralRightSafeCheckKPI,
                    loading: true,
                    error: ''
                }
            }

        case SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_SUCCESS:
            return {
                ...state,
                rssLateralRightSafeCheckKPI: {
                    ...state.rssLateralRightSafeCheckKPI,
                    loading: false,
                    error: '',
                    rssLateralRightCurrent: {
                        xAxis: action.payload['rss_lateral_right_current']['x-axis'],
                        yAxis: action.payload['rss_lateral_right_current']['y-axis']
                    },
                    rssLateralRightSafe: {
                        xAxis: action.payload['rss_lateral_right_safe']['x-axis'],
                        yAxis: action.payload['rss_lateral_right_safe']['y-axis']
                    },
                    rssLateralRightFlag: {
                        xAxis: action.payload['rss_lateral_right_flag']['x-axis'],
                        yAxis: action.payload['rss_lateral_right_flag']['y-axis']
                    },
                    overallRSSFlag: {
                        xAxis: action.payload['overall_rss_flag']['x-axis'],
                        yAxis: action.payload['overall_rss_flag']['y-axis']
                    }
                }
            }

        case SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_ERROR:
            return {
                ...state,
                rssLateralRightSafeCheckKPI: {
                    ...state.rssLateralRightSafeCheckKPI,
                    loading: false,
                    error: action.payload
                }
            }

        case SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_RESET:
            return RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_INITIAL_STATE;

        default:
            return state;
    }
}